import { Box } from "@mui/material";
import MetaTags from "react-meta-tags";

import { CONTACT_TITLE, CONTACT_LINK_CANONICAL } from "helpers/metatags";

import { ContactInfo } from "./components/ContactInfo";
import { GeneralInquiry } from "./components/GeneralInquiry";
import { TopBanner } from "./components/TopBanner";

export const Contact = () => (
  <Box component="article" width={1} className="contact-page">
    <MetaTags>
      <title>{CONTACT_TITLE}</title>
      <link rel="canonical" href={CONTACT_LINK_CANONICAL} />
    </MetaTags>

    <TopBanner />
    <GeneralInquiry />
    <ContactInfo />
  </Box>
);
